import { render, staticRenderFns } from "./Busy.vue?vue&type=template&id=69228771"
import script from "./Busy.vue?vue&type=script&lang=js"
export * from "./Busy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports